module.exports = __webpack_public_path__ + "static/img/gateway.1b0d318.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/gateway.jpg
// module id = ysAp
// module chunks = 2